import {CancelPolicyEnum} from '../booking/types'
import {CalculatedSubscription, SubscriptionDurationTypeEnum} from '../subscriptions/types'

export enum SubscriptionBookingStatusesEnum {
  OTHER = 'OTHER',
  ACTIVE = 'ACTIVE',
  FROZEN = 'FROZEN',
  EXPIRED = 'EXPIRED',
  INACTIVE = 'INACTIVE',
  CANCELLED = 'CANCELLED',
  AWAITING_PAYMENT = 'AWAITING_PAYMENT',
  PAYMENT_FAILED = 'PAYMENT_FAILED',
}

export type Cycle = {
  rolled?: boolean;
  disabled?: boolean;
  elIndex?: number;
  endDate: number;
  isPaid: boolean;
  payDate: number;
  startDate: number;
  toPay?: boolean;
  duration?: number;
  durationType?: string;
  paymentType?: string;
  price?: number;
  isFullMonth?: boolean;
  diffDaysForPayAccordingNow?: number;
}


export type BookedCycle = {
  expireDate: number;
  // rolled?: boolean;
  // disabled?: boolean;
  // elIndex?: number;
  endDate: number;
  isPaid: boolean;
  payDate: number;
  startDate: number;
  toPay?: boolean;
  duration?: number;
  durationType?: string;
  paymentType?: string;
  price: number;
  // Set on a cycle a promo code discounted: price is what was charged, listPrice before the code.
  listPrice?: number;
  promoDiscount?: number;
  invoicePdf?: string;
  isFullMonth?: boolean;
  isFirstUnpaid: boolean
  showInBilling: boolean
  credited: boolean
  // eslint-disable-next-line
  transactions: any[]// TODO: fix type
  // diffDaysForPayAccordingNow?: number;
}

export type SubscriptionBooking = {
  priceTime: number
  defaultCyclePrice: number
  uid: string
  additionalFee: number | null
  isPaidAdditionalFee: boolean | null
  cycles: BookedCycle[]
  status: SubscriptionBookingStatusesEnum.ACTIVE | SubscriptionBookingStatusesEnum.INACTIVE
  reference: string
  endDate?: number
  duration?: number
  subStatus?: SubscriptionBookingStatusesEnum.AWAITING_PAYMENT
    | SubscriptionBookingStatusesEnum.CANCELLED
    | SubscriptionBookingStatusesEnum.EXPIRED
    | SubscriptionBookingStatusesEnum.FROZEN
    | SubscriptionBookingStatusesEnum.PAYMENT_FAILED
  expireDate?: number
  durationType: SubscriptionDurationTypeEnum.DAYS
    | SubscriptionDurationTypeEnum.MONTHS
    | SubscriptionDurationTypeEnum.WEEKS
  membershipId: string
  usageStatuses: ('RUN_OUT' | 'RUNNING_OUT')[]
  cancelPolicy: CancelPolicyEnum | null
  membershipName: string
  coverEquipment: boolean
  cancel_timestamp?: number
  useForParticipants?: boolean
  membershipBookingId: string
  membershipBookingReference: string
  membershipData: CalculatedSubscription
  currentFreezePeriod?: {
    endDate?: number
    startDate?: number
  }
  logo: {
    secure_url: string
  }
  venueId: string
  userId: string
  memberId: string
  startDate: number
  paymentMethod: 'card'
  paymentMethodId: string | null
  requestToCancel: boolean
  promoCode?: string | null
  promoDiscount?: number | null
  promoApplied?: SubscriptionBookingPromo | null
}

// The code a pass was bought with, as the server stores it on the membership booking. Older
// bookings carry the pre-D364 keys (type / value / appliesTo) instead.
export type SubscriptionBookingPromo = {
  code?: string
  discountType?: 'FIXED' | 'PERCENT'
  discount?: number
  subscriptionDuration?: 'ALL_CYCLES' | 'FIRST_PAYMENT'
  type?: 'FIXED' | 'PERCENT'
  value?: number
  appliesTo?: 'allCycles' | 'firstPayment'
}

// A member's request to cancel a membership. The venue decides; a decision never moves money.
export enum MembershipCancelRequestStatusEnum {
  REQUESTED = 'requested',
  ACCEPTED = 'accepted',
  DECLINED = 'declined',
  WITHDRAWN = 'withdrawn',
}

export type MembershipCancelRequestDecision = {
  kind: 'full' | 'partial'
  // Minor units (for example satang for THB). 0 on a full accept: no separate figure.
  refundAmount: number
  currency: string
  // Readable label of the original payment method, copied at decision time.
  paidWith: string | null
  // The venue's terms text for the member.
  terms: string | null
}

export type MembershipCancelRequest = {
  uid: string
  venueId: string
  membershipBookingId: string
  userId: string
  membershipName: string
  memberName: string
  reason: string
  status: MembershipCancelRequestStatusEnum
  decision: MembershipCancelRequestDecision | null
  declineMessage: string | null
  createdAt: number
  updatedAt: number
  decidedAt: number | null
  decidedBy: string | null
  withdrawnAt: number | null
}
